import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const documentNumberingURL = `/api/v1/core-app/document-numbering`;

//obtaining the paginated data
export const getDocumentNumbering = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${documentNumberingURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllDocumentNumbering = () => axiosInstance.get(`${documentNumberingURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDocumentNumbering = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${documentNumberingURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getDocumentNumberingById = (id) => axiosInstance.get(`${documentNumberingURL}/retrieve/${id}`);

//creating function
export const createDocumentNumbering = (body) => axiosInstance.post(`${documentNumberingURL}/create`, body);
//updating function
export const updateDocumentNumbering = (id, body) => axiosInstance.patch(`${documentNumberingURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${documentNumberingURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDocumentNumberingName = (e, cancelToken) =>
  axiosInstance.get(`${documentNumberingURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
